import { api } from '../api';

export const socialService = {
  async fetchPages(params) {
    return api.get('social-pages', { params });
  },

  async fetchPage(id) {
    return api.get('social-pages/' + id );
  },

  async createPage(params) {
    return api.post('social-pages', params);
  },

  async updatePage(id, params) {
    return api.post('social-pages/' + id, { '_method': 'PUT', ...params });
  },

  async deletePage(id) {
    return api.delete('social-pages/' + id);
  },
};